module.exports = __webpack_public_path__ + "img/send-icon.e6f9236d.svg";